"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUNCH_WORKFLOW_ACTIONS = exports.PUNCH_WF_DATA_TEST_IDS = void 0;
var PUNCH_WF_DATA_TEST_IDS;
(function (PUNCH_WF_DATA_TEST_IDS) {
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW"] = "PunchWorkflow";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_SELECT_DATE"] = "PunchWorkflowSelectDate";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_SELECT_ACTION"] = "PunchWorkflowSelectAction";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_SELECT_PUNCH"] = "PunchWorkflowSelectPunch";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_EDIT_PUNCH"] = "PunchWorkflowEditPunch";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_REVIEW"] = "PunchWorkflowReview";
    PUNCH_WF_DATA_TEST_IDS["PUNCH_WORKFLOW_SUMMARY"] = "PunchWorkflowSummary";
})(PUNCH_WF_DATA_TEST_IDS = exports.PUNCH_WF_DATA_TEST_IDS || (exports.PUNCH_WF_DATA_TEST_IDS = {}));
var PUNCH_WORKFLOW_ACTIONS;
(function (PUNCH_WORKFLOW_ACTIONS) {
    PUNCH_WORKFLOW_ACTIONS["ADD"] = "Add";
    PUNCH_WORKFLOW_ACTIONS["EDIT"] = "Edit";
    PUNCH_WORKFLOW_ACTIONS["DELETE"] = "Delete";
})(PUNCH_WORKFLOW_ACTIONS = exports.PUNCH_WORKFLOW_ACTIONS || (exports.PUNCH_WORKFLOW_ACTIONS = {}));
